import type { HttpGet, HttpRequest } from '@/shared/infra/http'
import type { ProPromoCodeValidation } from '@/shared/domain'
import type { ValidateProPromoCode } from '@/modules/auth/use-cases'

export class EdgeValidateProPromoCodeRepository {
  constructor(private readonly httpClient: HttpGet) {}

  execute: ValidateProPromoCode = async (params) => {
    const search = new URLSearchParams({ code: params.code })
    const request: HttpRequest<never> = {
      url: `/pro-billing/validate-promo?${search.toString()}`,
    }
    return this.httpClient.get<ProPromoCodeValidation>(request)
  }
}
